import React, { useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import "./ExploreTopics.scss";

const ExploreTopics = () => {
  const data = useStaticQuery(graphql`
    query exploreQuery {
      allContentfulSubcategoria(
        filter: { contentful_id: { eq: "409cITTPuyHorR4bnTIBWl" } }
      ) {
        nodes {
          titulo
          referenciaSubcategorias {
            slug
            nombreSubcategoria
          }
          id
          contentful_id
        }
      }
    }
  `);

  const topics =
    data.allContentfulSubcategoria.nodes[0].referenciaSubcategorias;
    
  return (
    <div className="explore-topics">
      <div className="explore-topics__title">
        <h3>Explorar temas</h3>
      </div>
      <ul>
        {topics.map((topic, key) => (
          <li key={key}>
            <Link to={"/" + topic.slug}>
              {topic.nombreSubcategoria}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ExploreTopics;
